import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectLocation } from 'shared/selectors/location';
import { selectRegions } from 'shared/selectors/regions';
import { fetchCitiesByRegion } from 'shared/services/fetchCitiesByRegion';
import { IGetCitiesByRegionActionPayload } from 'shared/slices/geo/types';
import { TLocation } from 'shared/types/location';
import { IThunkApi } from 'shared/types/redux';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const loadLocationSwitcherData = createAsyncThunk<IGetCitiesByRegionActionPayload, void, IThunkApiExtended>(
  'geo/locationSwitcher/loadData',
  async (_, thunkApi) => {
    const { getState, rejectWithValue, extra: context } = thunkApi;
    const state = getState();

    const currentLocation = selectLocation(state);
    const regions = selectRegions(state);

    try {
      if (currentLocation === 'moscow_mo' || currentLocation === 'spb_lo') {
        return {
          selectedRegion: currentLocation,
          cities: [],
        };
      }

      if (currentLocation.parentId) {
        const cities = await fetchCitiesByRegion(context, { regionId: currentLocation.parentId });

        return {
          selectedCity: currentLocation,
          selectedRegion: regions.find(region => region.id === currentLocation.parentId) as TLocation,
          cities,
        };
      }

      const cities = await fetchCitiesByRegion(context, { regionId: currentLocation.id });

      return {
        selectedRegion: currentLocation,
        cities,
      };
    } catch (e) {
      return rejectWithValue();
    }
  },
);
